$(function  () {

  // VARIABLES

  const commentWrapper = $('.js-comment-section').hide()

  const buildComment = function () {
    const data = commentWrapper.data()
    const comment = commentWrapper.find('.js-comment')
    const avatar = commentWrapper.find('.js-avatar')
    const name = commentWrapper.find('.js-name')
    const profession = commentWrapper.find('.js-profession')

    const urlApi = window.location.origin + '/blog/wp-json/wp/v2/'

    $.ajax({
      url: `${urlApi}posts/${data.id}`,
      success: function (data) {
        comment.text(data.title.rendered)
        avatar.append(
          $('<img>')
            .attr('src', data.acf.avatar.url)
            .attr('alt', data.acf.avatar.name)
        )
        name.text(data.acf.name)
        profession.text(data.acf.profession)
        commentWrapper.show()
      }
    })
  }

  if (commentWrapper.length > 0) {
    buildComment()
  }

});
